import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaDashboard } from "@/components/agenda/agenda-dashboard";

export const Route = createFileRoute("/agenda/")({
  component: () => (
    <AgendaShell>
      <AgendaDashboard />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Dashboard — Agenda — GPS Drive" }] }),
});
